import { Taf } from "@huyafed/taf-network";

export var HUYA = HUYA || {};

HUYA.LuckyBagWebShareEvent = function () {
  this.tId = new HUYA.UserId();
  this.lPid = 0;
};

HUYA.LuckyBagWebShareEvent.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lPid = is.readInt64(1, false, this.lPid);
};

HUYA.LuckyBagWebShareEvent.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lPid);
};

HUYA.LuckyBagWebShareEvent.prototype._clone = function () {
  return new HUYA.LuckyBagWebShareEvent();
};
HUYA.LuckyBagWebShareEvent.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagWebShareEvent.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = "";
  this.sToken = "";
  this.sHuYaUA = "";
  this.sCookie = "";
  this.iTokenType = 0;
  this.sDeviceInfo = "";
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
};

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId();
};
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagCommRsp = function () {
  this.iCode = 0;
  this.sMsg = "";
};

HUYA.LuckyBagCommRsp.prototype.readFrom = function (is) {
  this.iCode = is.readInt32(0, false, this.iCode);
  this.sMsg = is.readString(1, false, this.sMsg);
};

HUYA.LuckyBagCommRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iCode);
  os.writeString(1, this.sMsg);
};

HUYA.LuckyBagCommRsp.prototype._clone = function () {
  return new HUYA.LuckyBagCommRsp();
};
HUYA.LuckyBagCommRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagCommRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagCommReq = function () {
  this.tId = new HUYA.UserId();
  this.lPid = 0;
};

HUYA.LuckyBagCommReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.lPid = is.readInt64(1, false, this.lPid);
};

HUYA.LuckyBagCommReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt64(1, this.lPid);
};

HUYA.LuckyBagCommReq.prototype._clone = function () {
  return new HUYA.LuckyBagCommReq();
};
HUYA.LuckyBagCommReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagCommReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.StartLuckyBagReq = function () {
  this.tId = new HUYA.UserId();
  this.iDuration = 0;
  this.iPartic = 0;
  this.iJoinMode = 0;
  this.sTerm = "";
  this.iHuyaBNum = 0;
  this.iAwardUsrNum = 0;
  this.sOrder = "";
};

HUYA.StartLuckyBagReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.iDuration = is.readInt32(1, false, this.iDuration);
  this.iPartic = is.readInt32(2, false, this.iPartic);
  this.iJoinMode = is.readInt32(3, false, this.iJoinMode);
  this.sTerm = is.readString(4, false, this.sTerm);
  this.iHuyaBNum = is.readInt32(5, false, this.iHuyaBNum);
  this.iAwardUsrNum = is.readInt32(6, false, this.iAwardUsrNum);
  this.sOrder = is.readString(7, false, this.sOrder);
};

HUYA.StartLuckyBagReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.iDuration);
  os.writeInt32(2, this.iPartic);
  os.writeInt32(3, this.iJoinMode);
  os.writeString(4, this.sTerm);
  os.writeInt32(5, this.iHuyaBNum);
  os.writeInt32(6, this.iAwardUsrNum);
  os.writeString(7, this.sOrder);
};

HUYA.StartLuckyBagReq.prototype._clone = function () {
  return new HUYA.StartLuckyBagReq();
};
HUYA.StartLuckyBagReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.StartLuckyBagReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.StartLuckyBagRsp = function () {
  this.iCode = 0;
  this.sMsg = "";
  this.lNumHuyaB = 0;
};

HUYA.StartLuckyBagRsp.prototype.readFrom = function (is) {
  this.iCode = is.readInt32(0, false, this.iCode);
  this.sMsg = is.readString(1, false, this.sMsg);
  this.lNumHuyaB = is.readInt64(2, false, this.lNumHuyaB);
};

HUYA.StartLuckyBagRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iCode);
  os.writeString(1, this.sMsg);
  os.writeInt64(2, this.lNumHuyaB);
};

HUYA.StartLuckyBagRsp.prototype._clone = function () {
  return new HUYA.StartLuckyBagRsp();
};
HUYA.StartLuckyBagRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.StartLuckyBagRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GetLuckyBagHistoryReq = function () {
  this.tId = new HUYA.UserId();
  this.iPos = 0;
  this.iLen = 0;
};

HUYA.GetLuckyBagHistoryReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.iPos = is.readInt32(1, false, this.iPos);
  this.iLen = is.readInt32(2, false, this.iLen);
};

HUYA.GetLuckyBagHistoryReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.iPos);
  os.writeInt32(2, this.iLen);
};

HUYA.GetLuckyBagHistoryReq.prototype._clone = function () {
  return new HUYA.GetLuckyBagHistoryReq();
};
HUYA.GetLuckyBagHistoryReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GetLuckyBagHistoryReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GetLuckyBagHistoryRsp = function () {
  this.iTotal = 0;
  this.iPos = 0;
  this.iLen = 0;
  this.vInfo = new Taf.Vector(new HUYA.LuckyBagInfo());
};

HUYA.GetLuckyBagHistoryRsp.prototype.readFrom = function (is) {
  this.iTotal = is.readInt32(0, false, this.iTotal);
  this.iPos = is.readInt32(1, false, this.iPos);
  this.iLen = is.readInt32(2, false, this.iLen);
  this.vInfo = is.readVector(3, false, this.vInfo);
};

HUYA.GetLuckyBagHistoryRsp.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iTotal);
  os.writeInt32(1, this.iPos);
  os.writeInt32(2, this.iLen);
  os.writeVector(3, this.vInfo);
};

HUYA.GetLuckyBagHistoryRsp.prototype._clone = function () {
  return new HUYA.GetLuckyBagHistoryRsp();
};
HUYA.GetLuckyBagHistoryRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GetLuckyBagHistoryRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagInfo = function () {
  this.lLuckyBagId = 0;
  this.lPid = 0;
  this.lStartTime = 0;
  this.lEndTime = 0;
  this.iState = 0;
  this.iPartic = 0;
  this.iJoinMode = 0;
  this.sTerm = "";
  this.iHuyaBNum = 0;
  this.iAwardUsrNum = 0;
  this.sOrder = "";
  this.lPayUid = 0;
  this.lNumBanner = 0;
  this.lNumView = 0;
  this.lNumJoin = 0;
  this.vAwardInfo = new Taf.Vector(new HUYA.LuckyBagAward());
  this.iSecret = 0;
  this.iBannerTaskId = 0;
  this.vAwardUI = new Taf.Vector(new HUYA.LuckyBagAwardUI());
  this.mCouponId2Type = new Taf.Map(new Taf.STRING(), new Taf.INT32());
  this.lSysPayUid = 0;
};

HUYA.LuckyBagInfo.prototype.readFrom = function (is) {
  this.lLuckyBagId = is.readInt64(0, false, this.lLuckyBagId);
  this.lPid = is.readInt64(1, false, this.lPid);
  this.lStartTime = is.readInt64(2, false, this.lStartTime);
  this.lEndTime = is.readInt64(3, false, this.lEndTime);
  this.iState = is.readInt32(4, false, this.iState);
  this.iPartic = is.readInt32(5, false, this.iPartic);
  this.iJoinMode = is.readInt32(6, false, this.iJoinMode);
  this.sTerm = is.readString(7, false, this.sTerm);
  this.iHuyaBNum = is.readInt32(8, false, this.iHuyaBNum);
  this.iAwardUsrNum = is.readInt32(9, false, this.iAwardUsrNum);
  this.sOrder = is.readString(10, false, this.sOrder);
  this.lPayUid = is.readInt64(11, false, this.lPayUid);
  this.lNumBanner = is.readInt64(12, false, this.lNumBanner);
  this.lNumView = is.readInt64(13, false, this.lNumView);
  this.lNumJoin = is.readInt64(14, false, this.lNumJoin);
  this.vAwardInfo = is.readVector(15, false, this.vAwardInfo);
  this.iSecret = is.readInt32(16, false, this.iSecret);
  this.iBannerTaskId = is.readInt32(17, false, this.iBannerTaskId);
  this.vAwardUI = is.readVector(18, false, this.vAwardUI);
  this.mCouponId2Type = is.readMap(19, false, this.mCouponId2Type);
  this.lSysPayUid = is.readInt64(20, false, this.lSysPayUid);
};

HUYA.LuckyBagInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lLuckyBagId);
  os.writeInt64(1, this.lPid);
  os.writeInt64(2, this.lStartTime);
  os.writeInt64(3, this.lEndTime);
  os.writeInt32(4, this.iState);
  os.writeInt32(5, this.iPartic);
  os.writeInt32(6, this.iJoinMode);
  os.writeString(7, this.sTerm);
  os.writeInt32(8, this.iHuyaBNum);
  os.writeInt32(9, this.iAwardUsrNum);
  os.writeString(10, this.sOrder);
  os.writeInt64(11, this.lPayUid);
  os.writeInt64(12, this.lNumBanner);
  os.writeInt64(13, this.lNumView);
  os.writeInt64(14, this.lNumJoin);
  os.writeVector(15, this.vAwardInfo);
  os.writeInt32(16, this.iSecret);
  os.writeInt32(17, this.iBannerTaskId);
  os.writeVector(18, this.vAwardUI);
  os.writeMap(19, this.mCouponId2Type);
  os.writeInt64(20, this.lSysPayUid);
};

HUYA.LuckyBagInfo.prototype._clone = function () {
  return new HUYA.LuckyBagInfo();
};
HUYA.LuckyBagInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagAward = function () {
  this.lUid = 0;
  this.sAwardInfo = "";
  this.tUsrInfo = new HUYA.LuckyBagUsr();
  this.iTotalPrice = 0;
  this.vAwardElems = new Taf.Vector(new HUYA.LuckyBagAwardElem());
};

HUYA.LuckyBagAward.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(1, false, this.lUid);
  this.sAwardInfo = is.readString(2, false, this.sAwardInfo);
  this.tUsrInfo = is.readStruct(4, false, this.tUsrInfo);
  this.iTotalPrice = is.readInt32(5, false, this.iTotalPrice);
  this.vAwardElems = is.readVector(6, false, this.vAwardElems);
};

HUYA.LuckyBagAward.prototype.writeTo = function (os) {
  os.writeInt64(1, this.lUid);
  os.writeString(2, this.sAwardInfo);
  os.writeStruct(4, this.tUsrInfo);
  os.writeInt32(5, this.iTotalPrice);
  os.writeVector(6, this.vAwardElems);
};

HUYA.LuckyBagAward.prototype._clone = function () {
  return new HUYA.LuckyBagAward();
};
HUYA.LuckyBagAward.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagAward.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagUsr = function () {
  this.sNick = "";
  this.sAvatar = "";
  this.sHuyaId = "";
};

HUYA.LuckyBagUsr.prototype.readFrom = function (is) {
  this.sNick = is.readString(0, false, this.sNick);
  this.sAvatar = is.readString(1, false, this.sAvatar);
  this.sHuyaId = is.readString(2, false, this.sHuyaId);
};

HUYA.LuckyBagUsr.prototype.writeTo = function (os) {
  os.writeString(0, this.sNick);
  os.writeString(1, this.sAvatar);
  os.writeString(2, this.sHuyaId);
};

HUYA.LuckyBagUsr.prototype._clone = function () {
  return new HUYA.LuckyBagUsr();
};
HUYA.LuckyBagUsr.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagUsr.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagAwardElem = function () {
  this.tAwardId = new HUYA.LuckyBagAwardId();
  this.iNum = 0;
};

HUYA.LuckyBagAwardElem.prototype.readFrom = function (is) {
  this.tAwardId = is.readStruct(0, false, this.tAwardId);
  this.iNum = is.readInt32(1, false, this.iNum);
};

HUYA.LuckyBagAwardElem.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tAwardId);
  os.writeInt32(1, this.iNum);
};

HUYA.LuckyBagAwardElem.prototype._clone = function () {
  return new HUYA.LuckyBagAwardElem();
};
HUYA.LuckyBagAwardElem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagAwardElem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagAwardId = function () {
  this.iType = 0;
  this.sId = "";
  this.sExArgs = "";
};

HUYA.LuckyBagAwardId.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.sId = is.readString(1, false, this.sId);
  this.sExArgs = is.readString(2, false, this.sExArgs);
};

HUYA.LuckyBagAwardId.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeString(1, this.sId);
  os.writeString(2, this.sExArgs);
};

HUYA.LuckyBagAwardId.prototype._clone = function () {
  return new HUYA.LuckyBagAwardId();
};
HUYA.LuckyBagAwardId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagAwardId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagAwardUI = function () {
  this.tAwardId = new HUYA.LuckyBagAwardId();
  this.sAwardName = "";
  this.sAwardIcon = "";
  this.iPrice = 0;
};

HUYA.LuckyBagAwardUI.prototype.readFrom = function (is) {
  this.tAwardId = is.readStruct(0, false, this.tAwardId);
  this.sAwardName = is.readString(1, false, this.sAwardName);
  this.sAwardIcon = is.readString(2, false, this.sAwardIcon);
  this.iPrice = is.readInt32(3, false, this.iPrice);
};

HUYA.LuckyBagAwardUI.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tAwardId);
  os.writeString(1, this.sAwardName);
  os.writeString(2, this.sAwardIcon);
  os.writeInt32(3, this.iPrice);
};

HUYA.LuckyBagAwardUI.prototype._clone = function () {
  return new HUYA.LuckyBagAwardUI();
};
HUYA.LuckyBagAwardUI.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagAwardUI.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagStartPanel = function () {
  this.lPid = 0;
  this.tCfgStart = new HUYA.LuckyBagStartCfg();
  this.iNumStarted = 0;
  this.iNumHuyaBSend = 0;
  this.lNumHuyaB = 0;
  this.iAuth = 0;
  this.sAuthMsg = "";
};

HUYA.LuckyBagStartPanel.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.tCfgStart = is.readStruct(1, false, this.tCfgStart);
  this.iNumStarted = is.readInt32(2, false, this.iNumStarted);
  this.iNumHuyaBSend = is.readInt32(3, false, this.iNumHuyaBSend);
  this.lNumHuyaB = is.readInt64(4, false, this.lNumHuyaB);
  this.iAuth = is.readInt32(5, false, this.iAuth);
  this.sAuthMsg = is.readString(6, false, this.sAuthMsg);
};

HUYA.LuckyBagStartPanel.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeStruct(1, this.tCfgStart);
  os.writeInt32(2, this.iNumStarted);
  os.writeInt32(3, this.iNumHuyaBSend);
  os.writeInt64(4, this.lNumHuyaB);
  os.writeInt32(5, this.iAuth);
  os.writeString(6, this.sAuthMsg);
};

HUYA.LuckyBagStartPanel.prototype._clone = function () {
  return new HUYA.LuckyBagStartPanel();
};
HUYA.LuckyBagStartPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagStartPanel.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagStartCfg = function () {
  this.iMaxDayStart = 0;
  this.iMinOnceHuyaB = 0;
  this.iMaxOnceHuyaB = 0;
  this.iMaxDayHuyaB = 0;
  this.iMPV = 0;
  this.vJoinMode = new Taf.Vector(new Taf.INT32());
  this.vPartic = new Taf.Vector(new Taf.INT32());
  this.vStartTime = new Taf.Vector(new Taf.INT32());
  this.vBarrage = new Taf.Vector(new Taf.STRING());
  this.vItem = new Taf.Vector(new Taf.STRING());
  this.iMPVFactor = 0;
};

HUYA.LuckyBagStartCfg.prototype.readFrom = function (is) {
  this.iMaxDayStart = is.readInt32(0, false, this.iMaxDayStart);
  this.iMinOnceHuyaB = is.readInt32(1, false, this.iMinOnceHuyaB);
  this.iMaxOnceHuyaB = is.readInt32(2, false, this.iMaxOnceHuyaB);
  this.iMaxDayHuyaB = is.readInt32(3, false, this.iMaxDayHuyaB);
  this.iMPV = is.readInt32(4, false, this.iMPV);
  this.vJoinMode = is.readVector(5, false, this.vJoinMode);
  this.vPartic = is.readVector(6, false, this.vPartic);
  this.vStartTime = is.readVector(8, false, this.vStartTime);
  this.vBarrage = is.readVector(9, false, this.vBarrage);
  this.vItem = is.readVector(10, false, this.vItem);
  this.iMPVFactor = is.readInt32(11, false, this.iMPVFactor);
};

HUYA.LuckyBagStartCfg.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iMaxDayStart);
  os.writeInt32(1, this.iMinOnceHuyaB);
  os.writeInt32(2, this.iMaxOnceHuyaB);
  os.writeInt32(3, this.iMaxDayHuyaB);
  os.writeInt32(4, this.iMPV);
  os.writeVector(5, this.vJoinMode);
  os.writeVector(6, this.vPartic);
  os.writeVector(8, this.vStartTime);
  os.writeVector(9, this.vBarrage);
  os.writeVector(10, this.vItem);
  os.writeInt32(11, this.iMPVFactor);
};

HUYA.LuckyBagStartCfg.prototype._clone = function () {
  return new HUYA.LuckyBagStartCfg();
};
HUYA.LuckyBagStartCfg.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagStartCfg.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LuckyBagPanel = function () {
  this.lPid = 0;
  this.lSrvTime = 0;
  this.tInfo = new HUYA.LuckyBagInfo();
  this.iJoinNum = 0;
  this.iParticState = 0;
  this.iTermState = 0;
  this.iAwardShowTime = 0;
  this.iGiftCostTotal = 0;
  this.iGiftCostMax = 0;
};

HUYA.LuckyBagPanel.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.lSrvTime = is.readInt64(1, false, this.lSrvTime);
  this.tInfo = is.readStruct(2, false, this.tInfo);
  this.iJoinNum = is.readInt32(3, false, this.iJoinNum);
  this.iParticState = is.readInt32(4, false, this.iParticState);
  this.iTermState = is.readInt32(5, false, this.iTermState);
  this.iAwardShowTime = is.readInt32(6, false, this.iAwardShowTime);
  this.iGiftCostTotal = is.readInt32(7, false, this.iGiftCostTotal);
  this.iGiftCostMax = is.readInt32(8, false, this.iGiftCostMax);
};

HUYA.LuckyBagPanel.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeInt64(1, this.lSrvTime);
  os.writeStruct(2, this.tInfo);
  os.writeInt32(3, this.iJoinNum);
  os.writeInt32(4, this.iParticState);
  os.writeInt32(5, this.iTermState);
  os.writeInt32(6, this.iAwardShowTime);
  os.writeInt32(7, this.iGiftCostTotal);
  os.writeInt32(8, this.iGiftCostMax);
};

HUYA.LuckyBagPanel.prototype._clone = function () {
  return new HUYA.LuckyBagPanel();
};
HUYA.LuckyBagPanel.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LuckyBagPanel.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.NotifyLuckyBagInfo = function () {
  this.lSrvTime = 0;
  this.tInfo = new HUYA.LuckyBagInfo();
};

HUYA.NotifyLuckyBagInfo.prototype.readFrom = function (is) {
  this.lSrvTime = is.readInt64(0, false, this.lSrvTime);
  this.tInfo = is.readStruct(1, false, this.tInfo);
};

HUYA.NotifyLuckyBagInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lSrvTime);
  os.writeStruct(1, this.tInfo);
};

HUYA.NotifyLuckyBagInfo.prototype._clone = function () {
  return new HUYA.NotifyLuckyBagInfo();
};
HUYA.NotifyLuckyBagInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.NotifyLuckyBagInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.NotifyLuckyBagTerm = function () {
  this.lPid = 0;
  this.lLuckyBagId = 0;
  this.lUid = 0;
};

HUYA.NotifyLuckyBagTerm.prototype.readFrom = function (is) {
  this.lPid = is.readInt64(0, false, this.lPid);
  this.lLuckyBagId = is.readInt64(1, false, this.lLuckyBagId);
  this.lUid = is.readInt64(2, false, this.lUid);
};

HUYA.NotifyLuckyBagTerm.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lPid);
  os.writeInt64(1, this.lLuckyBagId);
  os.writeInt64(2, this.lUid);
};

HUYA.NotifyLuckyBagTerm.prototype._clone = function () {
  return new HUYA.NotifyLuckyBagTerm();
};
HUYA.NotifyLuckyBagTerm.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.NotifyLuckyBagTerm.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};